<template>
  <v-expansion-panel>
    <v-expansion-panel-content>
      <div slot="header">Point Light Settings</div>
      <v-card>
        <v-card-text>
          <swatches v-model="node.colour" popover-to="left">
            <v-text-field slot="trigger" label="Colour" :value="node.colour" readonly>
              <template slot="prepend">
                <div
                  :style="{ background: node.colour }"
                  style="height: 25px; width: 25px; border-radius: 5px; border: 1px solid black;"
                />
              </template>
            </v-text-field>
          </swatches>
          <v-slider label="Intensity" v-model="node.intensity" thumb-label :min="0.1" :max="10" :step="0.1" />
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'

export default {
  name: 'PointLightSettings',
  components: {
    Swatches
  },
  props: {
    node: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>

</style>
